import request from '../../../shared/request'

export function getJobAias(job_id) {
  return request(`/job/job_aias/${job_id}/`)
}

export function getDashboardAias(assignedToId) {
  return request(`/dashboard/aia/${assignedToId}/`)
}

export function createJobAia(payload) {
  return request(`/job/job_aias/${payload.job_id}/`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateJobAia(payload) {
  return request(`/job/job_aias/${payload.job_aia_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteJobAia(payload) {
  return request(`/job/job_aias/${payload.job_aia_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function uploadAiaAttachments(payload) {
  return request(`/job/job_aias/${payload.aiaId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getAiaAttachments(aia_id) {
  return request(`/job/job_aias/${aia_id}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/job/job_aias/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteAiaAttachment(payload) {
  return request(`/job/job_aias/${payload.attachmentId}/attachment/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function getJobAiaActivities(aia_id) {
  return request(`/job/activities/aia/${aia_id}/`)
}

// notes
export function fetchAiaNote(payload) {
  return request(`/job/job_aias/${payload.aiaId}/notes`)
}

export function createAiaNote(payload) {
  return request(`/job/job_aias/${payload.aiaId}/notes`, {
    method: 'POST',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function editAiaNote(payload) {
  return request(`/job/job_aias/${payload.noteId}/notes`, {
    method: 'PUT',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function deleteAiaNote(payload) {
  return request(`/job/job_aias/${payload.noteId}/notes`, {
    method: 'DELETE',
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/aias.js